module.exports = __webpack_public_path__ + "static/media/golfer-4-a.3afbbfdd.png";